export const DOCUMENT_COLUMNS = [
  {
    id: "admin_document_page_table_name_tag",
    defaultMessage: "Tag",
    accessor: "tag",
    width: "5%",
  },
  {
    id: "admin_document_page_table_name_fiche",
    defaultMessage: "Fiche",
    accessor: "file_name",
    width: "5%",
  },
  {
    id: "admin_document_page_table_name_status",
    defaultMessage: "Status",
    accessor: "status",
    width: "5%",
  },
  {
    id: "admin_document_page_table_name_pays",
    defaultMessage: "Pays",
    accessor: "country_id",
    width: "5%",
  },
  {
    id: "admin_document_page_table_name_label",
    defaultMessage: "Label",
    accessor: "label",
    width: "5%",
  },
  {
    id: "admin_document_page_table_name_actions",
    defaultMessage: "Actions",
    width: "9%",
    accessor: "action",
  },
];

export const BRANCHES_COLUMNS = [
  {
    id: "admin_branch_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "5.1%",
  },
  {
    id: "admin_branch_page_table_name_name",
    defaultMessage: "Nom",
    width: "10.1%",
    accessor: "name",
  },
  {
    id: "admin_branch_page_table_name_address",
    defaultMessage: "Adresse",
    width: "9%",
    accessor: "address",
  },
  {
    id: "admin_branch_page_table_name_address_city",
    defaultMessage: "Ville",
    width: "10.1%",
    accessor: "address_city",
  },
  {
    id: "admin_branch_page_table_name_address_postal_code",
    defaultMessage: "Code postal",
    width: "10.1%",
    accessor: "address_postal_code",
  },
  {
    id: "admin_branch_page_table_name_phone_number",
    defaultMessage: "Téléphone",
    width: "10.1%",
    accessor: "phone_number",
  },
  {
    id: "admin_branch_page_table_name_actions",
    defaultMessage: "Actions",
    width: "9%",
    accessor: "action",
  },
];

export const COUNTRIES_COLUMNS = [
  {
    id: "admin_country_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "5.2%",
  },
  {
    id: "admin_country_page_table_name_name",
    defaultMessage: "Nom",
    width: "15%",
    accessor: "name",
  },
  {
    id: "admin_country_page_table_name_default_language",
    defaultMessage: "Langue par défaut",
    width: "11%",
    accessor: "default_language",
  },
  {
    id: "admin_country_page_table_name_mission_coefficient",
    defaultMessage: "Coefficient",
    width: "9%",
    accessor: "mission_coefficient",
  },
  {
    id: "admin_country_page_table_name_currencies",
    defaultMessage: "Devise",
    width: "11%",
    accessor: "currencies",
  },
  {
    id: "admin_country_page_table_name_default_cur",
    defaultMessage: "Devise par défaut",
    width: "9%",
    accessor: "default_cur",
  },

  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "9%",
    accessor: "action",
  },
];

export const COUNTRY_COEF_COLUMNS = [
  {
    id: "admin_country_coef_page_table_name_bottom_threshold",
    defaultMessage: "Seuil inférieur",
    accessor: "bottom_threshold",
    width: "15%",
  },
  {
    id: "admin_country_coef_page_table_name_upper_threshold",
    defaultMessage: "Seuil supérieur",
    accessor: "upper_threshold",
    width: "15%",
  },
  {
    id: "admin_country_coef_page_table_name_coefficient",
    defaultMessage: "Coefficient",
    accessor: "coefficient",
    width: "15%",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "9%",
    accessor: "action",
  },
];

export const CURRENCY_COLUMNS = [
  {
    id: "admin_currency_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "5%",
  },
  {
    id: "admin_currency_page_table_name_currency_name",
    defaultMessage: "Nom Devise",
    width: "20%",
    accessor: "currency_name",
  },
  {
    id: "admin_currency_page_table_name_currency_id",
    defaultMessage: "Symbole alphabétique",
    accessor: "currency_id",
    width: "20%",
  },
  {
    id: "admin_currency_page_table_name_currency_symbol",
    defaultMessage: "Symbole",
    accessor: "currency_symbol",
    width: "20%",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const JOBS_COLUMNS = [
  {
    id: "admin_job_page_table_name_en",
    defaultMessage: "Nom anglais",
    accessor: "en",
  },
  {
    id: "admin_job_page_table_name_fr",
    defaultMessage: "Nom français",
    accessor: "fr",
  },
  {
    id: "admin_job_page_table_name_category",
    defaultMessage: "Catégorie",
    accessor: "category",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const JOB_CATEGORIES_COLUMNS = [
  {
    id: "admin_job_categories_page_table_name_fr",
    defaultMessage: "Nom français",
    accessor: "fr",
  },
  {
    id: "admin_job_categories_page_table_name_en",
    defaultMessage: "Nom anglais",
    accessor: "en",
  },
  {
    id: "admin_job_categories_page_table_name_jobs",
    defaultMessage: "Métiers rattachés",
    accessor: "jobs_count",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const PROFILE_COLUMNS = [
  {
    id: "admin_profile_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "5%",
  },
  {
    id: "admin_profile_page_table_name_fr_m",
    defaultMessage: "Nom français (m)",
    width: "20%",
    accessor: "fr_m",
  },
  {
    id: "admin_profile_page_table_name_fr_f",
    defaultMessage: "Nom français (f)",
    accessor: "fr_f",
    width: "20%",
  },
  {
    id: "admin_profile_page_table_name_en_m",
    defaultMessage: "Nom anglais (m)",
    width: "20%",
    accessor: "en_m",
  },
  {
    id: "admin_profile_page_table_name_en_f",
    defaultMessage: "Nom anglais (f)",
    accessor: "en_f",
    width: "20%",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const REASON_LEAVE_COLUMNS = [
  {
    id: "admin_reasonleave_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "5%",
  },
  {
    id: "admin_reasonleave_page_table_name_en",
    defaultMessage: "Nom anglais",
    width: "20%",
    accessor: "en",
  },
  {
    id: "admin_reasonleave_page_table_name_fr",
    defaultMessage: "Nom français",
    accessor: "fr",
    width: "20%",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const RECRUITMENT_METHODS_COLUMNS = [
  {
    id: "admin_recruitment_method_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "5%",
  },
  {
    id: "admin_recruitment_method_page_table_name_en",
    defaultMessage: "Nom anglais",
    width: "20%",
    accessor: "en",
  },
  {
    id: "admin_recruitment_method_page_table_name_fr",
    defaultMessage: "Nom français",
    accessor: "fr",
    width: "20%",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const REGIONS_COLUMNS = [
  {
    id: "admin_region_coef_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "5%",
  },
  {
    id: "admin_region_coef_page_table_name_name",
    defaultMessage: "name",
    accessor: "name",
    width: "20%",
  },
  {
    id: "admin_region_coef_page_table_name_parent",
    defaultMessage: "parent",
    accessor: "parent",
    width: "20%",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const SYNTEC_COLUMNS = [
  {
    id: "admin_syntec_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "5%",
  },
  {
    id: "admin_syntec_page_table_name_name",
    defaultMessage: "Nom",
    width: "20%",
    accessor: "name",
  },
  {
    id: "admin_syntec_page_table_name_value",
    defaultMessage: "Valeur",
    width: "20%",
    accessor: "value",
  },
  {
    id: "admin_syntec_page_table_name_status",
    defaultMessage: "Status",
    width: "20%",
    accessor: "status",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const SYNTEC_POS_COEF_COLUMNS = [
  {
    id: "admin_syntec_coef_page_table_name_id",
    defaultMessage: "ID",
    accessor: "id",
    width: "7%",
  },
  {
    id: "admin_syntec_coef_page_table_name_value",
    defaultMessage: "Valeur",
    width: "15%",
    accessor: "value",
  },
  {
    id: "admin_syntec_coef_page_table_name_multiplier",
    defaultMessage: "Multiplieur",
    width: "12%",
    accessor: "multiplier",
  },
  {
    id: "admin_syntec_coef_page_table_name_function",
    defaultMessage: "Function",
    width: "25%",
    accessor: "function",
  },
  {
    id: "admin_syntec_coef_page_table_name_syntec",
    defaultMessage: "Syntec",
    width: "12%",
    accessor: "syntec",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "11%",
    accessor: "action",
  },
];

export const SYNTEC_POS_COEF_STAFF_COLUMNS = [
  {
    id: "admin_syntec_coef_page_table_name_contractual_status_id",
    defaultMessage: "Statut contractuel",
    width: "15%",
    accessor: "contractual_status_id",
  },
  {
    id: "admin_syntec_coef_page_table_name_position",
    defaultMessage: "Position",
    width: "15%",
    accessor: "position",
  },
  {
    id: "admin_syntec_coef_page_table_name_coefficient",
    defaultMessage: "Coefficient",
    width: "12%",
    accessor: "coefficient",
  },
  {
    id: "admin_syntec_coef_page_table_name_gross_conventional_minimum",
    defaultMessage: "Minima Conventionnel Brut",
    width: "25%",
    accessor: "gross_conventional_minimum",
  },
  {
    id: "admin_syntec_coef_page_table_name_syntec",
    defaultMessage: "Syntec",
    width: "12%",
    accessor: "syntec",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "11%",
    accessor: "action",
  },
];

export const TTV_COLUMNS = [
  {
    id: "admin_ttv_page_table_name_en",
    defaultMessage: "Nom anglais",
    accessor: "en",
  },
  {
    id: "admin_ttv_page_table_name_fr",
    defaultMessage: "Nom français",
    accessor: "fr",
  },
  {
    id: "admin_ttv_page_table_name_tag",
    defaultMessage: "Tag",
    accessor: "tag",
  },
  {
    id: "admin_ttv_page_table_name_hexa",
    defaultMessage: "Valeur hexadécimale",
    accessor: "hexa",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const VIEW_DETAILS_COLUMNS = [
  {
    id: "admin_show_by_id_variable",
    defaultMessage: "Variable",
    accessor: "col",
  },
  {
    id: "admin_show_by_id_value",
    defaultMessage: "Valeur",
    accessor: "value",
  },
];

export const APPEAL_COLUMNS = [
  {
    id: "admin_appeal_page_table_name_en",
    defaultMessage: "Nom anglais",
    accessor: "en",
  },
  {
    id: "admin_appeal_page_table_name_fr",
    defaultMessage: "Nom français",
    accessor: "fr",
  },
  {
    id: "admin_appeal_page_table_name_hexa",
    defaultMessage: "Valeur hexadécimale",
    accessor: "hexa",
  },
  {
    id: "admin_appeal_page_table_name_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const TYPE_COMPANIES_COLUMNS = [
  {
    id: "admin_typeCompanies_page_table_name_en",
    defaultMessage: "Nom anglais",
    accessor: "en",
  },
  {
    id: "admin_typeCompanies_page_table_name_fr",
    defaultMessage: "Nom français",
    accessor: "fr",
  },
  {
    id: "admin_typeCompanies_page_table_name_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const EXCHANGE_RATE = [
  {
    accessor: "base_currency_id",
    id: "admin_exchangeRate_page_table_name_base_currency_id",
    defaultMessage: "Devise de base",
  },
  {
    accessor: "objective_currency_id",
    id: "admin_exchangeRate_page_table_name_objective_currency_id",
    defaultMessage: "Devise objectif",
  },
  {
    accessor: "convertion_rate",
    id: "admin_exchangeRate_page_table_name_convertion_rate",
    defaultMessage: "Taux de conversion",
  },
  {
    accessor: "country_id",
    id: "admin_exchangeRate_page_table_name_country_id",
    defaultMessage: "Pays",
  },
  {
    accessor: "import_date",
    id: "admin_exchangeRate_page_table_name_import_date",
    defaultMessage: "Date d'importation",
  },
  {
    id: "admin_exchangeRate_page_table_name_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];
export const SECTOR_COLUMNS = [
  {
    id: "admin_sector_page_table_name_en",
    defaultMessage: "Nom anglais",
    accessor: "en",
  },
  {
    id: "admin_sector_page_table_name_fr",
    defaultMessage: "Nom français",
    accessor: "fr",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const BACKUP_MANAGER_COLUMNS = [
  {
    id: "admin_backup_manager_page_table_name_backup_manager_id",
    defaultMessage: "Backup manager",
    accessor: "backup_manager_id",
  },
  {
    id: "admin_backup_manager_page_table_name_backed_manager_id",
    defaultMessage: "Backed manager",
    accessor: "backed_manager_id",
  },
  {
    id: "admin_backup_manager_page_table_name_establishment_date",
    defaultMessage: "Date début",
    accessor: "establishment_date",
  },
  {
    id: "admin_backup_manager_page_table_name_establishment_date_end",
    defaultMessage: "Date de fin",
    accessor: "establishment_date_end",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];

export const COUNTRY_HOLIDAYS_COLUMNS = [
  {
    id: "country",
    defaultMessage: "Pays",
    accessor: "country_id",
  },
  {
    id: "year",
    defaultMessage: "année",
    accessor: "year",
  },
  {
    id: "holiday",
    defaultMessage: "Vacances",
    accessor: "holiday",
  },
  {
    id: "admin_actions",
    defaultMessage: "Actions",
    width: "8%",
    accessor: "action",
  },
];
